/**
 * Notifications Page - Shared ops inbox
 */

import React from "react";
import NotificationsView from "../features/notifications/views/NotificationsView.jsx";

const Notifications = () => <NotificationsView />;

export default Notifications;
